/**
 * Optivise Energy — Contact Form Handler
 */
document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('.oe-contact-section');
  if (!section) return;

  const form = document.getElementById('oe-contact-form');
  if (!form) return;

  const ajaxUrl = section.dataset.ajaxUrl;
  const nonce = section.dataset.nonce;
  const successEl = document.getElementById('oe-form-success');
  const errorEl = document.getElementById('oe-form-error');

  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    // Hide previous messages
    successEl.classList.remove('is-visible');
    errorEl.classList.remove('is-visible');

    const submitBtn = form.querySelector('button[type="submit"]');
    const originalText = submitBtn.textContent;
    submitBtn.textContent = 'Sending...';
    submitBtn.disabled = true;

    const formData = new FormData(form);
    formData.append('action', 'oe_contact_form');
    formData.append('nonce', nonce);

    try {
      const response = await fetch(ajaxUrl, {
        method: 'POST',
        body: formData,
      });

      const result = await response.json();

      if (result.success) {
        successEl.textContent = result.data.message;
        successEl.classList.add('is-visible');
        form.reset();
      } else {
        errorEl.textContent = result.data.message || 'Something went wrong.';
        errorEl.classList.add('is-visible');
      }
    } catch {
      errorEl.textContent = 'Network error. Please try again.';
      errorEl.classList.add('is-visible');
    }

    submitBtn.textContent = originalText;
    submitBtn.disabled = false;
  });
});
